'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _WorldTaxonomy = require('./WorldTaxonomy');

var _WorldTaxonomy2 = _interopRequireDefault(_WorldTaxonomy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _WorldTaxonomy2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/WorldTaxonomy/index.js
// module id = 701
// module chunks = 11